export default {
  /**
   * Navigations (main and submenus)
   */
  // Main navigation
  navigation: {
    routines: {
      title: 'Positive Actions',
      menuTitle: 'Positive Actions',
    },
  },
  // Participant submenu
  participantNavigation: {
    swap: {
      title: 'Participant',
      menuTitle: 'Heroic Choices',
    },
    swaps: {
      title: 'Participant',
      menuTitle: 'Heroic Choices',
    },
    routines: {
      title: 'Participant',
      menuTitle: 'Positive Actions',
    },
    smartSurvey: {
      title: 'Participant',
      menuTitle: 'Initial Questions',
    },
  },
  /**
   * Participant
   */
  // Participant details page
  participantDetails: {
    swapFlag: 'Swap available',
    smartSurveyFlag: 'Initial Questions Settings',
    surveyFlag: 'Survey available',
    journalFlag: 'Journal settings',
  },
  // Participant smart survey page
  participantSmartSurvey: {
    pageTitle: {
      bold: 'Initial',
      normal: 'Questions',
    },
  },
  // Participant Routines
  participantRoutines: {
    browseAndApplyButton: 'Browse and apply actions',
    // Remove all activities dialog
    removeAllActivities: {
      title: 'Remove all actions from this day?',
    },
  },
  // Participant Routines Progress
  participantRoutinesProgress: {
    sectionExercisesActivities: {
      title: 'Exercises & Actions',
      AM_Activities: 'Actions AM',
      PM_Activities: 'Actions PM',
    },
    sectionDailyPerformance: {
      exercisesAndActivities: 'Exercises & Actions',
      AM_Activities: 'Actions AM',
      PM_Activities: 'Actions PM',
      activitySkipped: 'Action skipped',
    },
  },
  // Participant Swaps
  participantSwaps: {
    notFound: 'There are no Heroic Choices',
  },
  // Participant Swap
  participantSwap: {
    notFound: 'Heroic Choice not found',
    goBackToSwaps: 'Go back to Heroic Choices',
    editSwap: 'Edit Heroic Choice',
    deleteSwap: 'Delete Heroic Choice',
  },
  // Participant Swap - Swap Dialog
  swapDialog: {
    swap: 'Heroic Choice',
  },
  // Participant Swap - Swap Entry Dialog
  swapEntryDialog: {
    swap: 'Heroic Choice',
  },
  // Add participant dialog
  addParticipantDialog: {
    swapFlag: 'Swap available',
    smartSurveyFlag: 'Initial Questions Settings',
    surveyFlag: 'Survey available',
    journalFlag: 'Journal settings',
  },
  /**
   * Routines (Exercises & Activities)
   */
  // Apply Routines from Participant Routines (RoutineParticipantApplyDialog)
  participantApplyRoutines: {
    title: 'Apply actions',
    submit: 'Apply actions',
  },
  // Sequence Participant Apply Dialog
  sequenceParticipantApplyRoutines: {
    title: 'Apply actions',
    submit: 'Apply actions',
  },
  // Apply routines form participant routines and apply sequence (action: applySequence)
  applySequence: {
    successMessage: 'Action assigned!',
  },
  // Edit activity modal
  editActivityModal: {
    title: 'Edit action',
    // Change participant exercise/activity (changeParticipantExercise)
    participantSuccessMessage: {
      activityLabel: 'Action',
    },
  },
  // Sequence Exercise Dialog
  sequenceExerciseDialog: {
    activityLabel: 'action',
  },
  exerciseDefinitionDialog: {
    ActivityLabel: 'Action',
    activityLabel: 'action',
    mobileMedia: 'Action thumbnail',
  },
  // Routines page (exercises.vue)
  routines: {
    tabActivities: 'Actions',
    tabRoutines: 'Routines',
    createAMPMActivity: 'Create AM/PM Actions',
    // v-dialog delete exercise
    removeThisActivity: {
      title: 'Are you really sure you want to delete this for EVERYONE?',
    },
    // v-dialog delete exercise folder
    removeExerciseFolder: {
      content: 'Are you really sure you want to delete this for EVERYONE?',
      optionRemoveAll: 'Remove all Actions and Folder',
      optionRemoveFolderOnly: 'Remove Folder and keep Actions',
    },
  },
  /**
   * Company (practice)
   */
  // Company details page
  companyDetails: {
    swapFlag: 'Swap available',
    smartSurveyFlag: 'Initial Questions Settings',
    surveyFlag: 'Survey available',
    journalFlag: 'Journal settings',
  },
  addPracticeDialog: {
    swapFlag: 'Swap available',
    smartSurveyFlag: 'Initial Questions Settings',
    surveyFlag: 'Survey available',
    journalFlag: 'Journal settings',
  },
  addPracticePatientDialog: {
    swapFlag: 'Swap available',
    smartSurveyFlag: 'Initial Questions Settings',
    surveyFlag: 'Survey available',
    journalFlag: 'Journal settings',
  },
  newPracticeUserDialog: {
    surveyFlag: 'Survey available',
  },
  practiceUserDialog: {
    surveyFlag: 'Survey available',
  },
  /**
   * Advisor Dashboard (Participant Dashboard screen)
   */
  participantsDashboard: {
    routines: 'Positive Actions',
    totalRoutines: 'Total Positive Actions',
    totalSwaps: 'Total Heroic Choices',
    swaps: 'Heroic Choices',
    lastUpdatedSwap: 'Last updated heroic choice',
    routinesSkipped: 'Positive Actions Skipped',
  },
  /**
   * Company Admin Dashboard (Advisor Dashboard screen)
   */
  advisorsDashboard: {
    routines: 'Positive Actions',
    totalRoutines: 'Total Positive Actions',
    totalSwaps: 'Total Heroic Choices',
    swaps: 'Heroic Choices',
    lastUpdatedSwap: 'Last updated heroic choice',
    routinesSkipped: 'Positive Actions Skipped',
  },
  /**
   * Media library
   */
  library: {
    createActivity: 'Create action',
    successCreateActivity: 'Action added!',
  },
}
